import { Component, OnInit, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { RoundListPipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-thresholding",
	templateUrl: "./thresholding.component.html",
	styleUrls: ["./thresholding.component.scss"],
	imports: [FormsModule, ActionButtonComponent, DvsChartComponent, RoundListPipe]
})
export class ThresholdingComponent implements OnInit {
	api = inject(ApiService);
	charting = inject(ChartingService);

	public treenodes: any[];
	public selectedConfig: AssetConfigWithAssets;
	public thresholdError: string;
	public thresholdComponents: APIResults.ComponentThreshold[] = null;
	public selectedComponent: APIResults.ComponentThreshold;
	public boxPlotOptions: Highcharts.Options;
	public newConfig: string;

	async ngOnInit() {
		await this.UpdateTree();
	}

	public async UpdateTree() {
		const [orgs, configs, assets] = await Promise.all([
			await this.api.GetOrganizations(),
			await this.api.GetAllConfigs(),
			await this.api.GetAllAssets(),
		]);
		for (const org of orgs as any) {
			const orgconfigs = configs.filter(item => item.organization_id === org.organization_id);
			for (const config of orgconfigs as any) {
				config.assets = assets.filter(item => item.asset_type_id === config.asset_type_id);
			}
			org.configs = orgconfigs;
		}
		this.treenodes = orgs;
	}

	public async ClickExpander($event: any) {
		$event.target.parentElement.classList.toggle("expanded");
	}

	public async ClickOrg($event: any) {
		$event.target.parentElement.classList.add("expanded");
	}

	public async ClickConfig($event: any, config: AssetConfigWithAssets) {
		const acqs = await this.api.GetAssetAcqCounts(config.asset_type_id, config.assets.map(item => item.asset_id));
		for (let i = 0; i < config.assets.length; i++) {
			config.assets[i].acqcount = acqs[i];
		}
		this.selectedConfig = config;
		await this.UpdateThresholds();
	}

	public async UpdateThresholds() {
		this.thresholdComponents = undefined;
		this.thresholdError = undefined;
		this.selectedComponent = undefined;
		this.newConfig = undefined;
		const selectedAssets = this.selectedConfig.assets.filter(item => item.checked);
		if (selectedAssets.length === 0) {
			this.thresholdComponents = null;
			return;
		}
		try {
			const result = await this.api.GetThresholdData(this.selectedConfig.asset_type_id, selectedAssets.map(item => item.asset_id));
			this.thresholdComponents = result.components;
			this.selectedComponent = this.thresholdComponents[0];
			this.UpdateComponent(this.thresholdComponents[0]);
			this.newConfig = result.xml;
		} catch (err) {
			this.thresholdError = DvsUtilities.GetRemoteErrorMessage(err, "Couldn't load threshold data");
		}
	}

	public async UpdateComponent(comp: APIResults.ComponentThreshold) {
		const selectedAssets = this.selectedConfig.assets.filter(item => item.checked);
		const categories = selectedAssets.map(item => item.asset_name);
		this.boxPlotOptions = this.charting.BoxPlotDefaults("Revised HI", categories, comp.stats, comp.outliers, "HI");
	}

	public async UploadConfig() {
		await this.api.UpdateConfig(this.selectedConfig.asset_type_id, this.newConfig);
	}
}

interface AssetConfigWithAssets extends APIResults.AssetConfig {
	assets: AssetSelectableWithAcqCount[];
}

interface AssetSelectableWithAcqCount extends APIResults.Asset {
	acqcount: number;
	checked: boolean;
}
